import { Maybe } from "@ispb/react-hooks"
import { Fragment, ReactNode } from "react"
import { Badge, Table } from "react-bootstrap"
import { When } from "react-if"
import { maybe } from "shared/maybe"
import { DEFAULT_TABLE_PROPS } from "ui/config"
import { ENERGIZED_COLOR, LOCKED_OUT_COLOR, PHOTO_COLUMN_STYLE, getControlPointStatus } from "./index.js"
import { PublicControlPoint, PublicExecution, PublicProcedure } from "./print.js"
import PublicThumbnail from "./PublicThumbnail.js"

export interface StepTableProps {

    readonly procedure: PublicProcedure
    readonly execution?: PublicExecution | undefined
    readonly actions?: ((controlPoint: PublicControlPoint, index: number) => ReactNode) | undefined

}

export default function StepTable(props: StepTableProps) {
    return (
        <Fragment>
            <Table {...DEFAULT_TABLE_PROPS}>
                <thead>
                    <tr>
                        <th>Photo</th>
                        <When condition={props.execution !== undefined}><th>Status</th></When>
                        <th>Step</th>
                        <th>Number</th>
                        <th>Isolation Device</th>
                        <th>Isolation Location</th>
                        <th>Energy Magnitude</th>
                        <th>Method Statement</th>
                        <th>Verification Statement</th>
                        <When condition={props.actions !== undefined}><th /></When>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.procedure.controlPoints.map((controlPoint, index) => {
                            const latestStatus = maybe(props.execution, execution => getControlPointStatus(controlPoint.id, execution.actions))
                            return (
                                <tr key={controlPoint.id}>
                                    <td style={PHOTO_COLUMN_STYLE}><Maybe value={controlPoint.photo} children={upload => <PublicThumbnail companyId={props.procedure.companyId} id={upload.id} upload={upload} />} /></td>
                                    {
                                        maybe(latestStatus, latestStatus => {
                                            return <td>{latestStatus ? <Badge bg={LOCKED_OUT_COLOR}>Locked Out</Badge> : <Badge bg={ENERGIZED_COLOR}>Energized</Badge>}</td>
                                        })
                                    }
                                    <td>{controlPoint.step}</td>
                                    <td>{controlPoint.energySource.prefix}-{controlPoint.number}</td>
                                    <td>{controlPoint.isolationDevice.name}</td>
                                    <td>{controlPoint.isolationLocation}</td>
                                    <td>{controlPoint.energyMagnitude} {controlPoint.energyMeasure.name}</td>
                                    <td>{controlPoint.methodOverride ?? controlPoint.isolationDevice.methodStatement}</td>
                                    <td>{controlPoint.verificationOverride ?? controlPoint.isolationDevice.verificationStatement}</td>
                                    {
                                        maybe(props.actions, actions => {
                                            return <td className="text-end">{actions(controlPoint, index)}</td>
                                        })
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </Table>
        </Fragment>
    )
}
